import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { useTheme } from '../context/ThemeContext';
import { IconHome, IconImage, IconBook, IconMicSmall, IconTrophy, IconMonitor, IconSun, IconMoon, IconLogo, IconLogOut } from '../components/Icons';
import './Admin.css';

const navItems = [
  { path: '/admin',              icon: <IconHome size={18} />, label: 'Dashboard' },
  { path: '/admin/gallery',      icon: <IconImage size={18} />, label: 'Gallery Photos' },
  { path: '/admin/publications', icon: <IconBook size={18} />,  label: 'Publications' },
  { path: '/admin/speaking',     icon: <IconMicSmall size={18} />, label: 'Speaking' },
  { path: '/admin/grants',       icon: <IconTrophy size={18} />, label: 'Awards & Grants' },
];

export default function AdminLayout({ children, title }) {
  const { logout }           = useAdminAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate             = useNavigate();
  const { pathname }         = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin'); };

  return (
    <div className="admin-layout">
      {/* Mobile Backdrop */}
      {mobileOpen && <div className="admin-sidebar-overlay" onClick={() => setMobileOpen(false)} />}

      <aside className={`admin-sidebar ${mobileOpen ? 'admin-sidebar--mobile-open' : ''}`}>
        <div className="admin-sidebar__brand" style={{ display: 'flex', alignItems: 'center', gap: '0.85rem' }}>
          <img src="/dr sofjan/2.jpeg" alt="Dr. Dicky Sofjan" className="admin-sidebar__brand-img" />
          <div>
            <span className="admin-sidebar__title">Content Manager</span>
            <span className="admin-sidebar__subtitle">Dr. Dicky Sofjan</span>
          </div>
        </div>
        <nav className="admin-sidebar__nav">
          {navItems.map(item => (
            <a
              key={item.path}
              href={item.path}
              className={`admin-sidebar__link ${pathname === item.path ? 'admin-sidebar__link--active' : ''}`}
              onClick={e => { e.preventDefault(); navigate(item.path); }}
            >
              <span className="admin-sidebar__link-icon">{item.icon}</span>
              {item.label}
            </a>
          ))}
          <div style={{ flex: 1 }} />
          <a href="/" target="_blank" rel="noopener noreferrer" className="admin-sidebar__link">
            <span className="admin-sidebar__link-icon"><IconMonitor size={18} /></span>
            View Public Site
          </a>
          <button className="admin-sidebar__link" onClick={toggleTheme}>
            <span className="admin-sidebar__link-icon">{theme === 'light' ? <IconMoon size={18} /> : <IconSun size={18} />}</span>
            {theme === 'light' ? 'Dark Mode' : 'Light Mode'}
          </button>
          <button className="admin-sidebar__link" onClick={handleLogout} style={{ color: '#fca5a5' }}>
            <span className="admin-sidebar__link-icon"><IconLogOut size={18} /></span>
            Logout
          </button>
        </nav>
        <div className="admin-sidebar__footer">
          <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.3)', lineHeight: 1.5 }}>
            Logged in as<br /><strong style={{ color: 'rgba(255,255,255,0.5)' }}>Dr. Dicky Sofjan</strong>
          </div>
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button className="admin-hamburger" onClick={() => setMobileOpen(true)} aria-label="Open Menu">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
            </button>
            <span className="admin-topbar__title">{title}</span>
          </div>
          <button className="btn btn-outline btn-sm" onClick={handleLogout}>Logout</button>
        </div>
        {children}
      </main>
    </div>
  );
}
